import React from 'react'
import { animated, useTrail } from 'react-spring'
// eslint-disable-next-line react/prop-types
const Skills = ({ page }) => {
  // eslint-disable-next-line react/prop-types
  const Trail = ({ children }) => {
    const items = React.Children.toArray(children)
    console.log(items)
    const trail = useTrail(items.length, {
      config: { mass: 5, tension: 2000, friction: 200 },
      opacity: 1,
      x: 0,
      from: {
        opacity: 0,
        x: 20,
      },
    })
    return (
      <div>
        {trail.map(({ height, ...style }, index) => (
          // eslint-disable-next-line react/no-array-index-key
          <animated.div key={index} style={style} className="trailsText">
            <animated.div style={{ height }}>{items[index]}</animated.div>
          </animated.div>
        ))}
      </div>
    )
  }

  function CodeButton({ text }) {
    return (
      <div className="codeBtn ">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="30"
          height="30"
          fill="#2b6d6f"
          viewBox="0 0 16 16"
        >
          <path d="M10.478 1.647a.5.5 0 1 0-.956-.294l-4 13a.5.5 0 0 0 .956.294l4-13zM4.854 4.146a.5.5 0 0 1 0 .708L1.707 8l3.147 3.146a.5.5 0 0 1-.708.708l-3.5-3.5a.5.5 0 0 1 0-.708l3.5-3.5a.5.5 0 0 1 .708 0zm6.292 0a.5.5 0 0 0 0 .708L14.293 8l-3.147 3.146a.5.5 0 0 0 .708.708l3.5-3.5a.5.5 0 0 0 0-.708l-3.5-3.5a.5.5 0 0 0-.708 0z" />
        </svg>
        <p>{text}</p>
      </div>
    )
  }

  return (
    <div className="skills-page-container">
      <Trail>
        {/* <div className="jumbo">Skillset</div>
        <div className="featured-text">Know what I love to do</div>
        <div>
          <ul>
            <li>React.js</li>
            <li>Python, C, C++</li>
            <li>Android Devlopment (React Native)</li>
            <li>Java, Javascript, MongoDB, MySQL</li>
            <li>TypeScript, Three.js/react-three/fiber, NextJS</li>
          </ul>
        </div> */}
        <div className="jumbo">Projects</div>
        <div className="card-container">
                  <div className="card">
        
            {/* <img src="./images/cirquip.webp" alt="Cirquip" /> */}
            <h1 className="title">ScreenShanti - Realtime Parental Control Android Application</h1>
            <p className="text">
              <ul>
                <li>
• The application captures an image of the mobile user every 10 seconds in the background and locks the mobile device when a child is detected.
                </li>
                <li>
• Tech Stack - Java, TensorflowLite, Python3, MLKit, Convolutional Neural Networks.
                </li>
                <li>• The android app is published on (Play Store) with 100+ downloads.</li>
              </ul>
              <a target='_blank' href="https://play.google.com/store/apps/details?id=com.screenshanti.childdetect&hl=en_US&pli=1">
                <CodeButton text="Play Store" />
              </a>
            </p>
            <div className="label">Java</div>
            <div className="label">React</div>
            <div className="label">TensorflowJS</div>
          </div>
            <div className="card">
            <h1 className="title">
              ItineraryPro - React, Firebase, OpenAI, OAuth
            </h1>
            <p className="text">
              <ul>
                <li>
• Developed full-stack travel itinerary recommendation web app as part of winning team at <b>Inspiron 2.0, National Level Hackathon</b>.

                </li>
                <li>
• Implemented AI-generated itineraries, Google OAuth, PDF report generation, Google Maps API, weather reports, popular spots recommendations, and browsing of existing itineraries.
                </li>
              </ul>
              <a target='_blank'  href="https://www.youtube.com/watch?v=KzEh2fWuZNU&ab_channel=kartikmandhan">
                <CodeButton text="YT Demo" />
              </a>
              <a target='_blank'  href="https://itinerary-pro.netlify.app">
                <CodeButton text="Try it" />
              </a>
            </p>
            <div className="label">OAuth</div>
            <div className="label">GPT-3</div>
            <div className="label">React</div>
            <div className="label">TailwindCSS</div>
          </div>

        </div>
        <div className="card-container">
          <div className="card">
            <h1 className="title">
              Blockchain based social media application - Blockchain Technology
            </h1>
            <p className="text">
              <ul>
                <li>
                  Developed a full stack social media application, with smart
                  contract on Ropsten testnet
                </li>
                <li>
                  Features:- Features - News feed, Discussion room,
                  Category-wise post, Vote up/Vote Down Post, Comments.
                </li>
              </ul>
              <a href="https://oppen-up.netlify.app/">
                <CodeButton text="Demo" />
              </a>
            </p>
            <div className="label">Solidity</div>
            <div className="label">React</div>
            <div className="label">AntDesign</div>
            <div className="label">Moralis</div>
          </div>
          <div className="card">
            <h1 className="title">
              Multithreading Library for Linux - Operating Systems
            </h1>
            <p className="text">
              <ul>
                <li>A user-level multithreading library using C language</li>
                <li>
                  Implemented one-one, many-one, many-many thread mapping models
                </li>
                <li>
                  Unit testing the parallel flow of execution with acutest.h
                  library
                </li>
              </ul>

              <a href="https://github.com/kartikmandhan/kthreads">
                <CodeButton text="Github" />
              </a>
            </p>
            <div className="label">C Programming</div>
            <div className="label">Linux</div>
            <div className="label">Unit Tests</div>
          </div>
        </div>
        
        <div className="card-container">
                  <div className="card">
            <h1 className="title">Bittorrent Client - Computer Networking</h1>
            <p className="text">
              <ul>
                <li>Torrent Client written in Python3.</li>
                <li>
                  Features:- Parsing Torrent files and connecting to peers,
                  Downloading from Peers and Uploading to Peers, Seeding,
                  Download and Upload Speed Control, Maximum Peer Connection
                  Control.
                </li>
                <li>Algorithms Implemented - Rarest First, Top Four.</li>
              </ul>
              <a href="https://github.com/kartikmandhan/bittorrentClient">
                <CodeButton text="Github" />
              </a>
            </p>
            <div className="label">Python3</div>
            <div className="label">Computer Networks</div>
          </div>

          <div className="card">
            <h1 className="title">
              Pathfinding Visualizer - Web application, Algorithms
            </h1>
            <p className="text">
              <ul>
                <li>
                  Developed an interactive web application where a user can
                  create a maze and visualize different pathfinding algorithms
                </li>
                <li>
                  Dijkstra's, A* Search, Breadth-First Search, and Depth-First
                  Search.
                </li>
              </ul>
              <a href="https://pfalgovisualizer.netlify.app/">
                <CodeButton text="Demo" />
              </a>
            </p>
            <div className="label">HTML</div>
            <div className="label">CSS3</div>
            <div className="label">Javascript</div>
            <div className="label">Algorithms</div>
          </div>
        </div>
      </Trail>
    </div>
  )
}

export default Skills
